import {
  DEFAULT_PAGINATION_ACTIVE_PAGE,
  DEFAULT_PAGINATION_RECORDS_COUNT,
} from "../CustomUIComponents/Pagination/PaginationConstants";
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

// Application version
export const APPLICATION_VERSION = "1.3.0";
export const EMPTY_STRING = "";
export const MAX_LENGTH_FOR_COMMON_FIELDS = {
  amount: 6,
  phoneNumberMobile: 9,
  companyName: 20,
};

export const BRANCHES = {
  Madrid1: "MADRID1",
  Madrid2: "MADRID2",
};

export const HTTP = {
  OK: 200,
};
export const BASE_API_URL = process.env.REACT_APP_API_URL;
//export const BASE_API_URL = "http://localhost:8080"; //server on same machine
// export const BASE_API_URL = "http://172.24.12.237:8080/quisqueya"; //dev
// export const BASE_API_URL = "http://172.24.15.111:8080";
//export const BASE_API_URL = "http://18.204.121.170/quisqueya"; //aws_qa
//export const BASE_API_URL = "http://35.171.56.40/quisqueya"; //aws_stage

export const API = {
  forgotPassword: BASE_API_URL + "/user/forgot-password",
  logout: BASE_API_URL + "/logout",
  login: BASE_API_URL + "/login",
  getLoanApplication: BASE_API_URL + "/loan/get",
  getReceipt: BASE_API_URL + "/loan/receipt",
  getLoanApplicationStatusCount: BASE_API_URL + "/dashboard/category-pie-chart",
  getLoanApplicationsBySearchFilter: BASE_API_URL + "/dashboard/search",
  getLoanApplicationsOnLoanPortfolio:
    BASE_API_URL + "/loanportfolio/search-filter",
  getBarGraphCount: BASE_API_URL + "/dashboard/loan-disbursement-graph",

  getUserList: BASE_API_URL + "/user/list",
  createUser: BASE_API_URL + "/user/create",
  updateUser: BASE_API_URL + "/user/update/",
  getUsersBySearchFilter: BASE_API_URL + "/user/search-filter",
  deactivateUser: BASE_API_URL + "/user/delete/",
  getProfile: BASE_API_URL + "/user/get-profile/",

  changePassword: BASE_API_URL + "/user/change-password",

  getProfilePic: BASE_API_URL + "/user/profile-pic/",
  uploadProfilePic: BASE_API_URL + "/user/profile-pic/",
  getClientInfoById: BASE_API_URL + "/client/get-info/",

  getUserRoles: BASE_API_URL + "/user/roles",
  getApplicationId: BASE_API_URL + "/loan",

  getAmortizationTable: BASE_API_URL + "/loan/amortization?loanId=",
  getEmiAmountSplitup: BASE_API_URL + "/loan/payment-splitup",

  getAuditTrail: BASE_API_URL + "/audit-trail/admin/search-filter",

  userAuditTrail: BASE_API_URL + "/audit-trail/user/search-filter",
  yearDropdownList: BASE_API_URL + "/audit-trail/archive/",
  generateAudit: BASE_API_URL + "/audit-trail/archive/",
  downloadLiveData: BASE_API_URL + "/loanportfolio/bulk/download",
};

// Date format
export const DATE_FORMAT = "DD/MM/YYYY";
export const NEW_DATE_FORMAT = "DD-MM-YYYY";
export const DATE_FORMAT_FOR_PAY = "YYYY-MM-DD";
export const DATE_FORMAT_MONTH = "D MMM YYYY";
// Time format
export const TIME_FORMAT = "hh:mm A";

// Date-Time format
export const DATE_TIME_FORMAT = "dddd DD MMM YYYY | h:mm a";
export const CONFIGURATION_DATE_TIME_FORMAT = "DD MMM YYYY | h:mm a";

//API response codes
export const API_RESPONSE_STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  USERNAME_ALREADY_EXIST: 1004,
  ROLE_NOT_FOUND: 1005,
  INVALID_EMAIL_ID: 1006,
  PAYMENT_NOT_ALLOWED: 1200,
  LOAN_APPLICATION_NOT_FOUND: 2001,
  LOAN_APPLICATION_NOT_CREATED: 2002,
  LOAN_UPDATE_NOT_ALLOWED: 2005,
  ANALYSIS_DATA_NOT_FOUND: 2009,
  INSUFFIECIENT_LOAN_APPLICATION_DATA: 2011,
  INVALID_EMI_CONFIGURATION: 2014,
  FAILED_TO_UPLOAD_FILE: 3001,
  DOCUMENT_NOT_FOUND: 4001,
  ALL_DOCUMENTS_ARE_NOT_UPLOADED: 4003,
  LOAN_APPLICATION_NOT_ASSIGNED_YET: 5002,
  ANALYSIS_DATA_IS_NOT_COMPLETED: 5005,
  NOTE_NOT_FOUND: 7001,
  NOTE_DELETE_NOT_ALLOWED: 7002,
  NOTE_UPDATE_NOT_ALLOWED: 7003,
  NOTE_CREATE_FAILED: 7004,
  VERSION_EXISTS: 9003,
  ALGORITHM_CANNOT_BE_ACTIVATED: 9008,
  BRANCHNAME_ALREADY_EXIST: 10003,

  NO_ACTIVE_CONFIGURATION_FOUND: 11001,
  INVALID_CONFIGURATION_FORMAT: 11002,
  NO_DRAFTED_CONFIGURATION_FOUND: 11003,
  NO_CONFIGURATION_FOUND: 11004,
  DRAFTED_CONFIGURATION_ALREAY_EXISTS: 11005,
  CONFIGURATION_CANNOT_BE_ACTIVATED: 11006,
  NOT_ALLOWED_TO_UPDATE_CONFIGURATION: 11007,
};

export const LOAN_APPLICATION_STATUS = {
  approved: "APPROVED",
  incomplete: "INCOMPLETE",
  inProcess: "INPROCESS",
  pending: "PENDING",
  submitted: "SUBMITTED",
  rejected: "REJECTED",
  created: "CREATED",
  updated: "UPDATED",
  disbursed: "DISBURSED",
  dismissed: "DISMISSED",
};

export const USER_ROLES = {
  admin: "ADMIN",
  cashier: "CASHIER",
  analyst: "ANALYST",
  configurator: "CONFIGURATOR",
  general_manager: "GENERAL_MANAGER",
  cashier_moderator: "CASHIER_MODERATOR",
  customer_care: "CUSTOMER_CARE",
  analyst_moderator: "ANALYST_MODERATOR",
  client: "CLIENT",
  operations_officer: "OPERATIONS_OFFICER",
  loan_portfolio_manager: "LOAN_PORTFOLIO_MANAGER",
  collections_officer: "COLLECTIONS_OFFICER",
  collections_moderator: "COLLECTIONS_MODERATOR",
};
export const DEFAULT_USER_SELECTION = "select User";

export const VERSION_TYPE = {
  active: "ACTIVE",
  inactive: "INACTIVE",
  drafted: "DRAFTED",
};

export const COLORS = {
  red: "#DE2929",
  green: "#63A813",
  orange: "#EC9D0E",
  lightGreen: "#D1C605",
  blue: "#2CA5EA",
  lightBlue: "#52CAAD",
  violet: "#9852DE",
  pink: "#d457ed",
  grey: "#6f7275",
};

export const NOTE_TYPE = {
  document: "DOCUMENT",
  reference: "REFERENCE",
  negotiation: "NEGOTIATION",
  basicInfo: "BASIC_INFO",
  addInfo: "ADDITIONAL_INFO",
  incomeAndExpenses: "MONTHLY_EXPENSE",
};
export const NOTES_TYPE = [
  "BASIC_INFO",
  "ADDITIONAL_INFO",
  "MONTHLY_EXPENSE",
  "DOCUMENT",
  "REFERENCE",
  "NEGOTIATION",
];

export const CONFIGURATION_MAPPING_FIELDS = {
  birthDate: "BIRTHDATE",
  country: "NATIONALITY",
  stayInSpain: "SPAIN_STAY",
  employmentSituation: "INCOME_SOURCE",
  jobTime: "JOB_TIME",
  totalIncome: "INCOME_LEVEL",
  paymentTotalIncome: "PAYMENT_TOTAL_INCOME",
  paymentIncomeMinusExpenses: "PAYMENT_AVAILABLE_INCOME",
  paymentOtherLoan: "PAYMENT_OTHER_LOAN_PAYMENTS",
  addressValidation: "ADDRESS_VALIDATION",
  validationByReference: "VALIDATION_BY_REFERENCE",
  reference1Validation: "REFERENCE_1",
  reference2Validation: "REFERENCE_2",
  annualCountOfTransaction: "ANNUAL_COUNT_OF_TRANSACTION",
  annualAmountSentOrTransferred: "ANNUAL_AMOUNT_SENT_OR_TRANSFERRED",
  yearsAsAnEurophileClient: "YEARS_AS_AN_EUROPHILE_CLIENT",
  beneficiaryRelationship: "BENEFICIARY_RELATIONSHIP",
  last5YearsBehaviorCurve: "LAST_5_YEARS_BEHAVIOR_CURVE",
};
export const ENCRYTION_DECRYPTION_KEY = "JSRAQGIjI2FuQ29zUDA3Nw==";

export const LOAN_CATEGORY_LEGEND = [
  {
    key: "ACTIVE",
    color: "#ffff00",
    value: "ACTIVE",
  },
  {
    key: "LEGAL",
    color: "#9acd32",
    value: "LEGAL",
  },
  {
    key: "W_OFF",
    color: "#90ee90",
    value: "W_OFF",
  },
  {
    key: "CLOSED",
    color: "#006400",
    value: "CLOSED",
  },
];
export const LOAN_APPLICATION_CATEGORY = [
  {
    value: "",
    name: "Seleccionar Categoría",
  },
  {
    value: "ACTIVE",
    name: "Activo",
  },
  {
    value: "LEGAL",
    name: "Legal",
  },
  {
    value: "W_OFF",
    name: "Castigado",
  },
  {
    value: "CLOSED",
    name: "Cerrado",
  },
];

export const SEARCH_FILTER_PAGES = {
  DASHBOARD: "DASHBOARD",
  USER_LIST: "USER_LIST",
};

export const DASHBOARD_FILTER = {
  dfd: "",
  dtd: "",
  fc: "",
  lid: "",
  oft: DEFAULT_PAGINATION_ACTIVE_PAGE,
  lmt: DEFAULT_PAGINATION_RECORDS_COUNT,
};

export const USER_LIST_FILTER = {
  un: "",
  uc: "",
  oft: DEFAULT_PAGINATION_ACTIVE_PAGE,
  lmt: DEFAULT_PAGINATION_RECORDS_COUNT,
};

export const URL_FILTER = {
  [APPLICATION_CONFIGURATIONS.path.dashboard]: {
    key: "DASHBOARD",
    filter: DASHBOARD_FILTER,
  },
  [APPLICATION_CONFIGURATIONS.path.userList]: {
    key: "USER_LIST",
    filter: USER_LIST_FILTER,
  },
};
